import React from 'react';
import { connect } from 'react-redux';
import { formatPricingFactorValue } from '../../../utils/packagesUtils';
import PricingFactorLabel from '../PricingFactorLabel';
import NumberedPricingFactor from '../NumberedPricingFactor';

const Revisions = ({ basicRev, standardRev, premiumRev }) => {
    if (!basicRev || !standardRev || !premiumRev) {
        return null;
    }

    return (
        <tr>
            <th>
                <PricingFactorLabel name={basicRev.name}/>
            </th>
            <NumberedPricingFactor value={formatPricingFactorValue(premiumRev.value)}/>
            <NumberedPricingFactor value={formatPricingFactorValue(standardRev.value)}/>
            <NumberedPricingFactor value={formatPricingFactorValue(basicRev.value)}/>
        </tr>
    );
};

const mapStateToProps = ({ packages }) => {
    const { packageList } = packages;

    return {
        basicRev: packageList[2].revisions,
        standardRev: packageList[1].revisions,
        premiumRev: packageList[0].revisions
    };
};

export { Revisions };
export default connect(mapStateToProps)(Revisions);
